import React from 'react';
import './ProctoringBlockModal.css';

export default function ProctoringBlockModal({ 
  isBlocked, 
  cameraIssue, 
  micIssue,
  onRetry 
}) {
  if (!isBlocked) return null;

  const getIssueMessage = () => {
    if (cameraIssue && micIssue) {
      return 'Camera and microphone are required to continue the exam.';
    } else if (cameraIssue) {
      return 'Camera is required to continue the exam. Please ensure your camera is enabled and your face is visible.';
    } else if (micIssue) {
      return 'Microphone is required to continue the exam. Please unmute your microphone.';
    }
    return 'Camera and microphone are required to continue the exam.';
  };

  const getIssueTitle = () => {
    if (cameraIssue && micIssue) {
      return 'Camera & Microphone Required';
    } else if (cameraIssue) {
      return 'Camera Required';
    } else if (micIssue) {
      return 'Microphone Required';
    }
    return 'Proctoring Required';
  };

  return (
    <div className="proctoring-block-overlay">
      <div className="proctoring-block-modal">
        <div className="proctoring-block-icon">
          {cameraIssue && micIssue ? '📷🎤' : cameraIssue ? '📷' : '🎤'}
        </div>
        <h2>{getIssueTitle()}</h2>
        <p className="proctoring-block-message">{getIssueMessage()}</p>
        
        {cameraIssue && (
          <div className="proctoring-block-checklist">
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Ensure your camera is enabled and not blocked</span>
            </div>
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Position your face clearly in front of the camera</span>
            </div>
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Ensure good lighting so your face is visible</span>
            </div>
          </div>
        )}

        {micIssue && (
          <div className="proctoring-block-checklist">
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Unmute your microphone (check keyboard mute button)</span>
            </div>
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Check browser permissions for microphone access</span>
            </div>
            <div className="checklist-item">
              <span className="checklist-icon">✓</span>
              <span>Ensure microphone is not disabled in system settings</span>
            </div>
          </div>
        )}

        <button 
          className="proctoring-block-retry-btn"
          onClick={onRetry}
        >
          Check Again
        </button>
      </div>
    </div>
  );
}

